import { render, staticRenderFns } from "./svg_add.vue?vue&type=template&id=215956d0&"
import script from "./svg_add.vue?vue&type=script&lang=js&"
export * from "./svg_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports